import React from 'react';
import {Control, UseFormRegister} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import {webhookAPI} from 'entities/notification';
import Webhook from 'shared/ui/icons/Webhook';
import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';

import NotifyChannelBlock from '../NotifyChannelBlock/NotifyChannelBlock';

interface INotifyWebhookProps {
    item?: IHttpMonitorOutput,
    control: Control<any>,
    register: UseFormRegister<any>,
}

const NotifyWebhook: React.FC<INotifyWebhookProps> = ({item, control, register}) => {
    const {data, isLoading} = webhookAPI.useGetActiveQuery();

    return (
        <NotifyChannelBlock
            items={data}
            isLoading={isLoading}
            getLabel={(webhook) => webhook.description ?? webhook.url}
            control={control}
            register={register}
            fieldName="webhooks"
            settingsField="notify_webhooks_settings"
            settings={item?.notify_webhooks_settings ?? []}
            icon={<Webhook color="colored"/>}
            connectIcon={<Webhook color="gray"/>}
            title={t`Вебхуки`}
            notConnectedText={t`Уведомления через вебхуки не подключены`}
            // eslint-disable-next-line max-len
            hint={t`Для отправки уведомлений о сбоях нужно подключить вебхук. После подключения вы сможете выбрать его в настройках монитора.`}
            premiumCondition="webhook_max_count_limit"
            bordered
            last
        />
    );
};

export default NotifyWebhook;
